import axios from 'axios';
import type { IArchiveByIdsRequest, IArchiveByIdsResponse } from '@bb/contacts';

const archiveByIds = async (contactIds: string[]) => {
  const config: IArchiveByIdsRequest = {
    url: '/contacts/archive/contact',
    method: 'post',
    data: { ids: contactIds },
  };

  const { data } = await axios.request<IArchiveByIdsResponse>(config);

  return data;
};

export default archiveByIds;
